var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-more", attrs: { name: "app_more", id: "app_more" } },
    [
      _c("div", { staticClass: "am-block dp-f" }, [
        _c("div", { staticClass: "block-content" }, [
          _c("h3", { staticClass: "block-title" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TITLE")) +
                "\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "block-subtitle" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(
                  _vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_SUBTITLE")
                ) +
                "\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "block-use nutstore1" }, [
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT1"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT2"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT3"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT4"))
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "block-pic",
          attrs: { src: require("../images/svg/home-more-bg1.svg"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "am-block dp-f reverse" }, [
        _c("img", {
          staticClass: "block-pic",
          attrs: { src: require("../images/svg/home-more-bg2.svg"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "block-content" }, [
          _c("ul", { staticClass: "block-use nutstore2" }, [
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT5"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT6"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT7"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT8"))
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_NUTSTORE_TEXT9"))
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "am-block dp-f" }, [
        _c("div", { staticClass: "block-content" }, [
          _c("h3", { staticClass: "block-title" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TITLE")) +
                "\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "block-subtitle" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_SUBTITLE")) +
                "\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "block-use eagle1" }, [
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT1")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT2")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT3")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT4")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "block-pic",
          attrs: { src: require("../images/svg/home-more-bg3.svg"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "am-block dp-f reverse" }, [
        _c("img", {
          staticClass: "block-pic",
          attrs: { src: require("../images/svg/home-more-bg4.svg"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "block-content" }, [
          _c("ul", { staticClass: "block-use eagle2" }, [
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT5")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT6")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT7")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT8")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_MORE_EAGLE_TEXT9")))
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }